<template>
    <div>
        <div class="institution">
            <div class="container">
                <h1 class="heading-1">Compte institution</h1>

                <p class="institution__name" v-if="getProfile">Nom : <span class="text-uppercase">{{ getProfile.nom }}</span></p>
                <div class="abonnements-wrapper">
                    <p class="abonnements-wrapper__subtitle">Abonnements :</p>
                    <div class="abonnements" v-if="getAbonnements">
                        <div class="abonnement" v-for="abonnement in getAbonnements" :key="abonnement.key">
                            <div class="abonnement--title">{{ abonnement.key }}</div>
                            <div class="abonnement--desc">Abonnement jusqu'au {{ getDate(abonnement.key) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="compte-user" v-if="getProfile">
            <div class="container">
                <h2 class="heading-1">Compte utilisateur</h2>

                <div class="infos">
                    Identifiant : {{ getProfile.identifiant }}<br />
                    Email : {{ getProfile.email }}
                </div>

                <a class="btn btn-logout" @click="setLogout">Déconnexion</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from "moment"

export default {
    name: "ProfilePPage",
    computed: {
        ...mapGetters([
            'getProfile',
            'getAbonnements'
        ]),
    },
    methods: {
        ...mapActions([
            'setLogout'
        ]),
        getDate(value) {
            let date_end = '1970-01-01';
            const abo = this.getAbonnements.filter(f => f.key === value);
            if (abo.length > 0) {
                const current_abo = abo[0];
                current_abo.period.forEach((el) => {
                    if (el.end_date > date_end) {
                        date_end = el.end_date;
                    }
                });
            }
            return moment(date_end).format('DD/MM/YYYY');
        }
    },
    watch: {
        getAbonnements: {
            immediate: true,
            deep: true
        }
    }
}

</script>

<style lang="scss" scoped>
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.institution {
    max-width: 100%;
    margin-right: auto;
    // background: #283861;
    padding: 45px 20px 40px;
    border-bottom-left-radius: 80% 15px;
    border-bottom-right-radius: 80% 15px;
    overflow: hidden;
    background-image: url('@/assets/images/patern_grey.png');

    @include min($lg) {
        border-bottom-left-radius: 50% 15px;
        border-bottom-right-radius: 50% 15px;
        padding: 83px 20px 60px;
    }

    &__name {
        margin: 0 0 20px;
    }

    .abonnements {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        .abonnement {
            flex: 0 0 25%;

            // margin: 20px 0;
            @media screen and (max-width:768px) {
                flex: 1 0 41%;
            }

            &--title {
                font-family: $campaign;
                font-size: 12px;
                font-weight: $bold;
                line-height: 14px;
            }

            &--desc {
                font-size: 10px;
                line-height: 1;
            }
        }
    }
}

.abonnements-wrapper {
    &__subtitle {
        margin-bottom: 23px;
    }
}

.container {
    max-width: 800px;
}

.compte-user {
    padding: 45px 20px 60px;

    @include min($lg) {
        padding: 68px 20px 84px;
    }

    .btn-logout {
        cursor: pointer;
        width: 100%;

        @include min($lg) {
            width: auto;
        }
    }

    .infos {
        margin: 10px 0 20px;
        color: #283861;
    }
}
</style>